module.exports = __webpack_public_path__ + "img/CFishingBoat64_ua.bcb57d66.webp";